// extracted by mini-css-extract-plugin
module.exports = {"answer":"Answer_answer__Smpmy","answer__input":"Answer_answer__input__u_YCP","answer__button":"Answer_answer__button__yXJaU"};